import { useEffect, useState } from "react";

export default function QuickActionContactModal({ open, loading, onClose, onSubmit, initialContact = null, title = "Contactpersoon toevoegen" }) {
  const [naam, setNaam] = useState("");
  const [role, setRole] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const [submitError, setSubmitError] = useState("");

  useEffect(() => {
    if (!open) return;
    setNaam(String(initialContact?.naam || initialContact?.name || ""));
    setRole(String(initialContact?.role || initialContact?.functie || ""));
    setPhone(String(initialContact?.phone || initialContact?.telefoon || ""));
    setEmail(String(initialContact?.email || ""));
    setIsDefault(Boolean(initialContact?.isDefault));
    setSubmitError("");
  }, [initialContact, open]);

  if (!open) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitError("");
    try {
      await onSubmit({ naam, role, phone, email, isDefault });
      setNaam("");
      setRole("");
      setPhone("");
      setEmail("");
      setIsDefault(false);
    } catch (error) {
      setSubmitError(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Contactpersoon opslaan mislukt."
      );
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-5 shadow-xl">
        <h3 className="text-lg font-semibold text-slate-900">{title}</h3>

        <form onSubmit={handleSubmit} className="mt-4 space-y-3">
          {submitError ? (
            <div className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">
              {submitError}
            </div>
          ) : null}
          <input className="w-full rounded-lg border border-slate-200 px-3 py-2" placeholder="Naam" value={naam} onChange={(e) => setNaam(e.target.value)} required />
          <input className="w-full rounded-lg border border-slate-200 px-3 py-2" placeholder="Functie / rol" value={role} onChange={(e) => setRole(e.target.value)} />
          <input className="w-full rounded-lg border border-slate-200 px-3 py-2" placeholder="Telefoon" value={phone} onChange={(e) => setPhone(e.target.value)} />
          <input className="w-full rounded-lg border border-slate-200 px-3 py-2" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} />

          <label className="flex items-center gap-2 text-sm text-slate-700">
            <input type="checkbox" checked={isDefault} onChange={(e) => setIsDefault(e.target.checked)} />
            Als hoofdcontactpersoon instellen
          </label>

          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={onClose} className="rounded-lg border border-slate-200 px-4 py-2 text-sm" disabled={loading}>
              Annuleren
            </button>
            <button type="submit" className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white" disabled={loading}>
              {loading ? "Opslaan..." : "Opslaan"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
